// TaskList.tsx
import {NavLink, Outlet, useLocation} from 'react-router-dom';
import {useState} from 'react';
import {Loading} from "../../components/common/Loading";

const TaskList = () => {
    const [workType, setWorkType] = useState('ALL');
    const [activeTab, setActiveTab] = useState('matching');
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    const isFindTaskPage = location.pathname.includes('findTask');

    return (
        <>
            <Loading loading={loading} onClose={() => setLoading(false)}/>
            <main className="container has-tab type_gray">
                {/* 탭 */}
                <section className="tabFixed">
                    <ul className="tab_wrap col2">
                        <li>
                            <NavLink
                                to="findTask"
                                className={({isActive}) => isActive ? 'active' : ''}
                            >
                                일감찾기
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="myTask"
                                className={({isActive}) => isActive ? 'active' : ''}
                            >
                                내 일감
                            </NavLink>
                        </li>
                    </ul>
                </section>

                {/* 필터 */}
                <section>
                    <div className="inner">
                        {isFindTaskPage ? (
                            <div className="filter-wrap">
                                <span className="filter">
                                    <input
                                        type="radio"
                                        id="radio1"
                                        name="workType"
                                        checked={workType === 'ALL'}
                                        onChange={() => setWorkType('ALL')}
                                    />
                                    <label htmlFor="radio1">전체</label>
                                </span>
                                <span className="filter">
                                    <input
                                        type="radio"
                                        id="radio2"
                                        name="workType"
                                        checked={workType === 'HOURLY'}
                                        onChange={() => setWorkType('HOURLY')}
                                    />
                                    <label htmlFor="radio2">시간제</label>
                                </span>
                                <span className="filter">
                                    <input
                                        type="radio"
                                        id="radio3"
                                        name="workType"
                                        checked={workType === 'DAILY'}
                                        onChange={() => setWorkType('DAILY')}
                                    />
                                    <label htmlFor="radio3">종일제</label>
                                </span>
                            </div>
                        ) : (
                            <div className="filter-wrap">
                                <span className="filter">
                                    <input
                                        type="radio"
                                        id="taskTab1"
                                        name="taskTab"
                                        checked={activeTab === 'matching'}
                                        onChange={() => setActiveTab('matching')}
                                    />
                                    <label htmlFor="taskTab1">매칭중</label>
                                </span>
                                <span className="filter">
                                    <input
                                        type="radio"
                                        id="taskTab2"
                                        name="taskTab"
                                        checked={activeTab === 'ongoing'}
                                        onChange={() => setActiveTab('ongoing')}
                                    />
                                    <label htmlFor="taskTab2">진행중</label>
                                </span>
                                <span className="filter">
                                    <input
                                        type="radio"
                                        id="taskTab3"
                                        name="taskTab"
                                        checked={activeTab === 'completed'}
                                        onChange={() => setActiveTab('completed')}
                                    />
                                    <label htmlFor="taskTab3">완료</label>
                                </span>
                            </div>
                        )}
                    </div>
                </section>

                {/* 탭별 내용 */}
                <Outlet context={{workTypeFilter: workType, setLoading, activeTab}}/>
            </main>
        </>
    );
};

export default TaskList;
